module.exports = __webpack_public_path__ + "static/CF-spaceman-whiteArtboard-1-2x-a4c63d7b0067a00b90fb0bd0c3d9a0eb.png";